<template>
	<div id="page_wrapper" class="page-template-default page page-id-826 woocommerce-no-js res1170 kl-follow-menu kl-skin--light">

		<div class="zn_pb_wrapper clearfix zn_sortable_content" data-droplevel="0">
			<div class="kl-slideshow static-content__slideshow nobg eluid2483a282 maskcontainer--mask3 ">
				<div class="kl-slideshow-inner static-content__wrapper  static-content--height">
					<div class="static-content__source ">
						<div class="zn-bgSource ">
							<div class="zn-bgSource-image" style="background-image:url(https://casainterior.eu/ny.jpg);background-repeat:repeat;background-position:center center;background-size:cover;background-attachment:scroll"></div>
							<div class="zn-bgSource-overlay" style="background-color:rgba(0,0,0,0.4)"></div>
						</div>
						<div class="th-sparkles"></div>
					</div>
					<div class="static-content__inner container">
						<div class="kl-slideshow-safepadding  sc__container ">
							<div class="static-content default-style static-content--with-login">
								<div class="row">
									<div class="col-sm-10 col-sm-offset-1 col-md-7 col-md-offset-0">
										<h2 class="static-content__title" itemprop="headline">HEY THERE!</h2>
										<h3 class="static-content__subtitle" itemprop="alternativeHeadline"><span class="fw-thin">This is  Theme, <span class="fw-semibold">an epic and wonderful premium</span> piece of work, for the typical modern website.</span></h3></div>
										<div class="col-sm-10 col-sm-offset-1 col-md-5 col-md-offset-0">
											<div class="fancy_register_form">
												<form  class="th-register-form register_form_static form-horizontal zn_form_login" action="#" @submit.prevent="login">
													<div class="zn_form_login-result"></div>

													<div class="form-group">
														<label class="col-sm-4 control-label" for="username">Email</label>
														<div class="col-sm-8">
															<input type="text" name="username" id="username" class="form-control inputbox required" placeholder="Your email" v-model="email" />
															<div class="error">
																<!-- <span> Моля попълнете email</span> -->
															</div>

														</div>
													</div>
													<div class="form-group">
														<label class="col-sm-4 control-label" for="password">Your password</label>
														<div class="col-sm-8">
															<input type="password" name="password" id="password" class="form-control inputbox"  placeholder="Your password" v-model="password" />
															<div class="error">
																<!-- <span> Моля попълнете password</span> -->
															</div>
														</div>
													</div>

													<div class="form-group">
														<div class="col-sm-8 col-sm-offset-4">
															<!--<input type="submit" class="zn_sub_button btn btn-fullcolor th-button-register" value="ENTER" />-->
															<button type="submit">Готово</button>
														</div>
													</div>
													<div class="form-group error">
														<div class="col-sm-8 col-sm-offset-4">
															<!-- <span>Дани за акаунт не е валидни!!!</span> -->
														</div>
													</div>
												</form>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>	
	</template>

	<script>
		export default {
			data() {
				return {
					email: '',
					password: '',
				}
			},
			methods: {
				login() {
					this.$store.dispatch('retrieveToken', {
						email: this.email,
						password: this.password,
					})
					.then(response => {
				
						this.$router.push({ name: 'home' })

						iziToast.show({
							color: 'dark',
							icon: 'fa fa-envelope-open-o',
							title: 'System',
							message: 'Welcome! have a nice work!',
							position: 'topRight', 
							progressBarColor: '#777',

						});
					})
					.catch(error => {
iziToast.error({title: 'Error', message: 'Грешно потребителско име или парола.', position: 'topRight'});

					})
				}
			}
		}
	</script>

	<style scoped>
	/*! CSS Used from: http://localhost:3000/css/login.css */
	@media all{
		strong{font-weight:bold;}
		input{color:inherit;font:inherit;margin:0;}
		input[type="submit"]{-webkit-appearance:button;cursor:pointer;}
		input::-moz-focus-inner{border:0;padding:0;}
		input{line-height:normal;}
		@media print{
			*,*:before,*:after{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important;}
			h2,h3{orphans:3;widows:3;}
			h2,h3{page-break-after:avoid;}
		}
		*{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
		*:before,*:after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
		input{font-family:inherit;font-size:inherit;line-height:inherit;}
		h2,h3,h4{font-family:inherit;font-weight:500;line-height:1.1;color:inherit;}
		h2,h3{margin-top:20px;margin-bottom:10px;}
		h4{margin-top:10px;margin-bottom:10px;}
		h2{font-size:30px;}
		h3{font-size:24px;}
		h4{font-size:18px;}
		.text-center{text-align:center;}
		.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}
		@media (min-width:768px){
			.container{width:750px;}
		}
		@media (min-width:992px){
			.container{width:970px;}
		}
		@media (min-width:1200px){
			.container{width:1170px;}
		}
		.row{margin-left:-15px;margin-right:-15px;}
		.col-sm-4,.col-md-5,.col-md-7,.col-sm-8,.col-sm-10{position:relative;min-height:1px;padding-left:15px;padding-right:15px;}
		@media (min-width:768px){
			.col-sm-4,.col-sm-8,.col-sm-10{float:left;}
			.col-sm-10{width:83.33333333%;}
			.col-sm-8{width:66.66666667%;}
			.col-sm-4{width:33.33333333%;}
			.col-sm-offset-4{margin-left:33.33333333%;}
			.col-sm-offset-1{margin-left:8.33333333%;}
		}
		@media (min-width:992px){
			.col-md-5,.col-md-7{float:left;}
			.col-md-7{width:58.33333333%;}
			.col-md-5{width:41.66666667%;}
			.col-md-offset-0{margin-left:0;}
		}
		label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:bold;}
		.form-control{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,0.075);box-shadow:inset 0 1px 1px rgba(0,0,0,0.075);-webkit-transition:border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;-o-transition:border-color ease-in-out .15s, box-shadow ease-in-out .15s;transition:border-color ease-in-out .15s, box-shadow ease-in-out .15s;}
		.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);}
		.form-control::-moz-placeholder{color:#999;opacity:1;}
		.form-control:-ms-input-placeholder{color:#999;}
		.form-control::-webkit-input-placeholder{color:#999;}
		.form-control::-ms-expand{border:0;background-color:transparent;}
		.form-group{margin-bottom:15px;}
		.form-horizontal .form-group{margin-left:-15px;margin-right:-15px;}
		@media (min-width:768px){
			.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px;}
		}
		.btn{display:inline-block;margin-bottom:0;font-weight:normal;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
		.btn:focus,.btn:active:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;}
		.btn:hover,.btn:focus{color:#333;text-decoration:none;}
		.btn:active{outline:0;background-image:none;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);box-shadow:inset 0 3px 5px rgba(0,0,0,0.125);}
		.clearfix:before,.clearfix:after,.container:before,.container:after,.row:before,.row:after,.form-horizontal .form-group:before,.form-horizontal .form-group:after{content:" ";display:table;}
		.clearfix:after,.container:after,.row:after,.form-horizontal .form-group:after{clear:both;}
		h2,h3,h4{font-family:Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif;}
		h2,h3,h4{font-weight:700;}
		.fw-thin{font-weight:300!important;}
		.fw-semibold{font-weight:600!important;}
		#page_wrapper{position:relative;overflow:hidden;height:100vh;z-index:0;}
		.form-control:focus{border-color:rgba(0,0,0,.26);box-shadow:inherit;}
		@media (max-width:991px){
			.btn{white-space:normal;}
		}
		.btn.btn-fullcolor{border-width:0;}
		.btn.btn-fullcolor{text-shadow:none;padding:10px 20px;line-height:1.6;box-shadow:none;font-size:13px;font-weight:700;border-style:solid;border-radius:3px;transition:background-color .15s ease-out;}
		.btn.btn-fullcolor,.btn.btn-fullcolor:focus{background-color:#006886;color:#fff;}
		.btn.btn-fullcolor:hover{color:#fff;}
		.zn-bgSource-overlay{position:absolute;top:0;left:0;bottom:0;right:0;}
		.zn-bgSource-overlay{pointer-events:none;}
		.maskcontainer--mask3{border-bottom:0!important;padding-bottom:35px;}
		.kl-slideshow-inner{position:relative;z-index:1;}
		.kl-slideshow{margin-bottom:0;}
		.kl-slideshow .kl-slideshow-safepadding{padding-top:35px;padding-bottom:35px;}
		@media screen and (min-width:480px){
			.zn_pb_wrapper>.kl-slideshow:first-child .kl-slideshow-safepadding{padding-top:150px;padding-bottom:45px;}
		}
		.kl-slideshow{position:relative;top:0;z-index:0;width:100%;}
		.static-content__slideshow[class*=maskcontainer--]{padding-bottom:0;}
		.static-content__slideshow[class*=maskcontainer--] .kl-slideshow-inner{padding-bottom: 203px;}
		.th-sparkles{display:none;}
		strong{font-weight:inherit;}
		strong{font-weight:bolder;}
		input{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0;}
		input{overflow:visible;}
		[type=submit]{-webkit-appearance:button;}
		[type=submit]::-moz-focus-inner{border-style:none;padding:0;}
		[type=submit]:-moz-focusring{outline:1px dotted ButtonText;}
		.text-center{text-align:center;}
		.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;}
		@media (min-width:768px){
			.container{width:750px;}
		}
		@media (min-width:992px){
			.container{width:970px;}
		}
		@media (min-width:1200px){
			.container{width:1170px;}
		}
		.row{margin-left:-15px;margin-right:-15px;}
		.col-sm-4,.col-md-5,.col-md-7,.col-sm-8,.col-sm-10{position:relative;min-height:1px;padding-left:15px;padding-right:15px;}
		@media (min-width:768px){
			.col-sm-4,.col-sm-8,.col-sm-10{float:left;}
			.col-sm-10{width:83.33333333%;}
			.col-sm-8{width:66.66666667%;}
			.col-sm-4{width:33.33333333%;}
			.col-sm-offset-4{margin-left:33.33333333%;}
			.col-sm-offset-1{margin-left:8.33333333%;}
		}
		@media (min-width:992px){
			.col-md-5,.col-md-7{float:left;}
			.col-md-7{width:58.33333333%;}
			.col-md-5{width:41.66666667%;}
			.col-md-offset-0{margin-left:0;}
		}
		.clearfix:before,.clearfix:after,.container:before,.container:after,.row:before,.row:after,.form-horizontal .form-group:before,.form-horizontal .form-group:after{content:" ";display:table;}
		.clearfix:after,.container:after,.row:after,.form-horizontal .form-group:after{clear:both;}
		.zn-bgSource,.zn-bgSource-overlay,.zn-bgSource-image{position:absolute;top:0;left:0;bottom:0;right:0;width:100%;height:100%;overflow:hidden;}
		.zn-bgSource-image{background-position:center;background-repeat:no-repeat;background-size:cover;background-attachment:fixed;}
		.zn-bgSource-overlay{pointer-events:none;}
		.static-content__wrapper{width:100%;overflow:hidden;}
		.static-content__source+.static-content__inner{position:relative;}
		.static-content__source{position:absolute;top:0;left:0;bottom:0;right:0;height:100%;width:100%;}
		@media only screen and (min-width :1200px){
			.static-content--height .static-content__inner{position:relative;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);}
		}
		.static-content{color:#fff;padding-top:20px;}
		.static-content__title{font-size:64px;text-shadow:1px 1px 0 rgba(0,0,0,.3);line-height:1.3;}
		.static-content__subtitle{font-size:32px;font-weight:400;text-shadow:1px 1px 0 rgba(0,0,0,.3);line-height:1.4;}
		.static-content--with-login .static-content__title{margin-top:60px;}
		.fancy_register_form{margin-top:70px;padding:25px 30px 10px;background:rgba(255,255,255,.3);color:#fff;position:relative;}
		.fancy_register_form form{margin:0;}
		.fancy_register_form label{display:inline-block;color:#fff;font-size:14px;text-shadow:0 1px 0 rgba(0,0,0,.5);font-weight:400;}
		.fancy_register_form .form-control{padding:10px 15px;}
		.fancy_register_form:after{content:'';position:absolute;bottom:-25px;left:100px;border-top:25px solid #fff;border-right:25px solid transparent;opacity:.3;}
		@media (min-width:768px){
			.fancy_register_form .control-label{padding-top:7px;}
		}
		@media only screen and (min-width :992px) and (max-width :1279px){
			.static-content__title{font-size:48px;}
			.static-content__subtitle{font-size:28px;}
		}
		@media only screen and (max-width :991px){
			.static-content__title{font-size:32px;}
			.static-content__subtitle{font-size:22px;}
		}
		@media only screen and (max-width :767px){
			.static-content__title,.static-content__subtitle{word-break:normal;}
		}
		@media only screen and (min-width :1200px){
			.eluid2483a282 .static-content--height{height:820px;}
		}
		h2{font-family:"Montserrat",Helvetica,Arial,sans-serif;font-size:30px;line-height:40px;font-weight:400;font-style:normal;}
		h3{font-family:"Open Sans",Helvetica,Arial,sans-serif;font-size:24px;line-height:40px;font-weight:400;font-style:normal;}
		h4{font-family:"Open Sans",Helvetica,Arial,sans-serif;font-size:18px;line-height:28px;font-weight:400;font-style:normal;}
		.btn.btn-fullcolor,.btn.btn-fullcolor:focus{background-color:#006886;}
		.btn.btn-fullcolor:hover{background-color:#ccc;}
	}
	@media print{
		@media print{
			.kl-slideshow,.btn{display:none;}
			[class*=col-]{width:100%;}
		}
	}
	.zn_pb_wrapper>.kl-slideshow:first-child .kl-slideshow-safepadding{padding-top:0;}
</style>


// WEBPACK FOOTER //
// src/components/pages/login.vue